import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOutIcon, UrbanCompassLogoBlack } from '../../../icons';
import { useAuth } from '../../../hooks/useAuth';
import { IntlMessages } from '../../../helper/langHelper';
import {
  clearCache,
  clearCacheOverlaysScreenshots,
  clearSummaryCache,
} from '../../../helper/cacheHelper';
import { clearItem } from '../../../helper/localStorageHelper';

import useOverlayStore from '../../../store/overlayStore';
import useShapeStore from '../../../store/shapeStore';
import { useQueryClient } from '@tanstack/react-query';
import Cache from '../../../helper/globalCacheHelper';
import { Nav, LogoutButton, Logo } from '../navbar/navbar.styles';

const MapperNavbar = () => {
  const navigate = useNavigate();

  const { logout } = useAuth();
  const { clearOverlayData } = useOverlayStore();
  const { resetAll } = useShapeStore();
  const queryClient = useQueryClient();

  const handleLogout = () => {
    queryClient.clear();
    queryClient.removeQueries();
    clearCache();
    clearSummaryCache();
    Cache.clearAllCaches();
    clearCacheOverlaysScreenshots();
    clearItem('applicationId');
    clearItem('procedure');
    clearItem('screenshotId');
    clearItem('image-store');
    clearItem('procedurePermit');
    clearOverlayData();
    resetAll();
    logout();
    navigate('/', { replace: true });
  };

  return (
    <Nav>
      <Logo>
        <UrbanCompassLogoBlack color={'#000'} onClick={() => navigate('/')} />
      </Logo>

      <div style={{ display: 'flex', gap: '10px' }}>
        <LogoutButton onClick={handleLogout}>
          <LogOutIcon /> <IntlMessages id="button.logout" />
        </LogoutButton>
      </div>
    </Nav>
  );
};

export default MapperNavbar;
